module.exports = dot

/**
 * Calculates the dot product of two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} dot product of a and b
 */
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1]
}


//////////////////
// WEBPACK FOOTER
// ./~/gl-vec2/dot.js
// module id = 46
// module chunks = 0